import { Sponsor } from './customTypes';

import aeronautecLogo from '../sponsorsLogos/aeronautec.png';
import dlrgLogo from '../sponsorsLogos/dlrg.png';
import gluecksburgLogo from '../sponsorsLogos/gluecksburg.png';
import groemitzLogo from '../sponsorsLogos/groemitz.png';
import kellenhusenLogo from '../sponsorsLogos/kellenhusen.png';
import kupferschmiedeLogo from '../sponsorsLogos/kupferschmiede.png';
import neustadtLogo from '../sponsorsLogos/neustadt.png';
import parkerLogo from '../sponsorsLogos/parker.png';
import syltLogo from '../sponsorsLogos/sylt.png';
import chiemgauLogo from '../sponsorsLogos/chiemgauTherme.png';
import dorfwirtLogo from '../sponsorsLogos/derDorfwirt.png';
import aokLoko from '../sponsorsLogos/aok.png';
import gesundheitsregionLogo from '../sponsorsLogos/gesundheitsregion.png';
import altoettingLogo from '../sponsorsLogos/altoetting.png';
import tusLogo from '../sponsorsLogos/tus.png';
import dlrgSuederluegumLogo from '../sponsorsLogos/dlrgSuederluegum.png';
import landsbergAmLechLogo from '../sponsorsLogos/landsbergAmLechLogo.png';
import ingolstadtLogo from '../sponsorsLogos/ingolstadtLogo.png';
import rosenheimLogo from '../sponsorsLogos/rosenheimLogo.png';
import brkWasserwachtLogo from '../sponsorsLogos/brkWasserwacht.png';
import buchbachLogo from '../sponsorsLogos/buchbachLogo.svg';
import behoerdeHamburgLogo from '../sponsorsLogos/behoerdeHamburg.png';
import dlrgDarmstadtLogo from '../sponsorsLogos/dlrgDarmstadt.png';
import ebersbergLogo from '../sponsorsLogos/ebersberg.png';
import freibadKaltenkirchenLogo from '../sponsorsLogos/freibadKaltenkirchen.png';
import mainSpessartLogo from '../sponsorsLogos/mainSpessart.png';
import alzeyLogo from '../sponsorsLogos/alzeyStadt.png';
import alzeySchwimmbadLogo from '../sponsorsLogos/alzeySchwimmbad.png';
import alzeyWormsLogo from '../sponsorsLogos/alzeyWorms.png';
import gsMainSpessartLogo from '../sponsorsLogos/gesundheitsamtMainSpessart.png';
import kielerBaederLogo from '../sponsorsLogos/kielerBaeder.png';
import koelnBaederLogo from '../sponsorsLogos/koelnBaeder.png';
import msdLogo from '../sponsorsLogos/msd.png';
import calevorniaLogo from '../sponsorsLogos/calevornia.png';
import leverkusenSportparkLogo from '../sponsorsLogos/leverkusenSportpark.png';
import mainzUniMedizinLogo from '../sponsorsLogos/mainzUniMedizin.png';
import saarbrueckenBaederLogo from '../sponsorsLogos/saarbrueckenBaeder.png';
import wiembachtalLogo from '../sponsorsLogos/wiembachtal.png';
import aokPlusLogo from '../sponsorsLogos/aokPlus.png';
import landratsamtLudwigsburgLogo from '../sponsorsLogos/ludwigsburg.png';
import kreisverwaltungSaarpfalzLogo from '../sponsorsLogos/saarpfalz.png';
import stadtparkNorderstedtLogo from '../sponsorsLogos/stadtparkNorderstedt.png';
import landratsamtBambergLogo from '../sponsorsLogos/gesundheitsregionPlusBamberg.png';
import segebergLogo from '../sponsorsLogos/segeberg.png';
import freibadLentfoehrdenLogo from '../sponsorsLogos/freibadLentfoehrden.png';
import henstedtUlzburgLogo from '../sponsorsLogos/henstedtUlzburg.png';
import aokLogo from '../sponsorsLogos/aok.svg';
import berchtesgadenerLandLogo from '../sponsorsLogos/berchtesgadenerLand.svg';
import golfclubMuensterLogo from '../sponsorsLogos/golfclubMuenster.png';
import marburgBiedenkopfLogo from '../sponsorsLogos/marburgBiedenkopf.jpg';
import eberswaldeLogo from '../sponsorsLogos/eberswalde.png';
import bayreuthLogo from '../sponsorsLogos/gesundheitsregionBayreuth.png';
import barnimLogo from '../sponsorsLogos/barnim.png';
import wormsLogo from '../sponsorsLogos/worms.png';
import bayreuthPlusLogo from '../sponsorsLogos/gesundheitsregionPlusBayreuth.png';
import laGeSoLogo from '../sponsorsLogos/laGeSo.jpg';
import waldbadLamspringeLogo from '../sponsorsLogos/waldbad_lamspringe.png';
import aokRheinlandHamburgLogo from '../sponsorsLogos/aok_rheinland_hamburg.png';
import siegenLogo from '../sponsorsLogos/siegen.jpg';
import herscheidLogo from '../sponsorsLogos/herscheid.webp';
import felsenbadLandsbergLogo from '../sponsorsLogos/felsenbadLandsberg.png';
import wasserweltLangenhagenLogo from '../sponsorsLogos/wasserweltLagenhagen.webp';
import stadtwerkeRoesrathLogo from '../sponsorsLogos/stadtwerkeRoesrath.webp';
import gochnessBadLogo from '../sponsorsLogos/gochnessBad.png';
import ettenheimLogo from '../sponsorsLogos/ettenheim.png';

export const sponsors: Sponsor[] = [
    {
        name: 'aeronautec',
        logo: aeronautecLogo,
        link: 'https://www.aeronautec.net/',
    },
    {
        name: 'Campingplatz Kupferschmiede',
        logo: kupferschmiedeLogo,
        link: 'https://www.campingkupferschmiede.de/',
    },
    {
        name: 'Parker Outdoor',
        logo: parkerLogo,
        link: 'https://parkeroutdoor.com/',
    },
    {
        name: 'Insel Sylt Tourismus-Service',
        logo: syltLogo,
        link: 'https://www.insel-sylt.de/',
    },
    {
        name: 'Tourismus-Service Ostseebad Kellenhusen',
        logo: kellenhusenLogo,
        link: 'https://www.kellenhusen.de/',
    },
    {
        name: 'Tourismus-Service Neustadt-Pelzerhaken-Rettin ',
        logo: neustadtLogo,
        link: 'https://www.stadt-neustadt.de/',
    },
    {
        name: 'Deutsche Lebens-Rettungs-Gesellschaft',
        logo: dlrgLogo,
        link: 'https://www.dlrg.de/',
    },
    {
        name: 'Der Dorfwirt St. Georgen',
        logo: dorfwirtLogo,
        link: 'https://www.derdorfwirt.eu/',
    },
    {
        name: 'Tourist-Information Glücksburg',
        logo: gluecksburgLogo,
        link: 'https://www.gluecksburg-urlaub.de/',
    },
    {
        name: 'Grömitz - Ostseebad der Sonnenseite',
        logo: groemitzLogo,
        link: 'https://www.groemitz.de/',
    },
    {
        name: 'Chiemgau Thermen Bad Endorf',
        logo: chiemgauLogo,
        link: 'https://www.chiemgau-thermen.de/',
    },
    {
        name: 'AOK',
        logo: aokLoko,
        link: 'https://www.aok.de',
    },
    {
        name: 'GesundheitsregionPlus Mühldorf a. Inn',
        logo: gesundheitsregionLogo,
        link: 'https://www.lra-mue.de/gesundheit-tiere-lebensmittel/gesundheit/gesundheitsregion-plus',
    },
    {
        name: 'Landratsamt Altötting',
        logo: altoettingLogo,
        link: 'https://www.lra-aoe.de/',
    },
    {
        name: 'TuS Traunreut',
        logo: tusLogo,
        link: 'https://www.tustraunreut.de/',
    },
    {
        name: 'DLRG Süderlügum',
        logo: dlrgSuederluegumLogo,
        link: 'https://amt-suederluegum.dlrg.de',
    },
    {
        name: 'Gesundheitsamt Ingolstadt',
        logo: ingolstadtLogo,
        link: 'https://www.ingolstadt.de/gesundheitsregionplus',
    },
    {
        name: 'Landsberg am Lech',
        logo: landsbergAmLechLogo,
        link: 'https://www.landkreis-landsberg.de/soziales-gesundheit/gesundheitsamt/?url=%2FGesundheit-Soziales%2FGesundheitsamt%2FGesundheitsamt.aspx%3Fview%3D~%2Fkxp%2Forgdata%2Fdefault%26orgid%3Dddde84d8-7027-498b-87a6-1ba5eb180135&cHash=8a157888fec4cc8390a3d435f480af1b#/',
    },
    {
        name: 'Gesundheitsamt Rosenheim',
        logo: rosenheimLogo,
        link: 'https://www.landkreis-rosenheim.de',
    },
    {
        name: 'Kreiswasserwacht Ingolstadt',
        logo: brkWasserwachtLogo,
        link: 'https://www.wasserwacht-ingolstadt.de/',
    },
    {
        name: 'Grund- und Mittelschule Buchbach',
        logo: buchbachLogo,
        link: 'https://www.schulebuchbach.de/',
    },
    {
        name: 'Behörde für Justiz und Verbraucherschutz Hamburg',
        logo: behoerdeHamburgLogo,
        link: 'https://justiz.hamburg.de/justizbehoerde',
    },
    {
        name: 'DLRG Darmstadt',
        logo: dlrgDarmstadtLogo,
        link: 'https://darmstadt.dlrg.de/',
    },
    {
        name: 'Stadt Ebersberg',
        logo: ebersbergLogo,
        link: 'https://www.ebersberg.de/',
    },
    {
        name: 'Freibad Kaltenkirchen',
        logo: freibadKaltenkirchenLogo,
        link: '',
    },
    {
        name: 'Main Spessart',
        logo: mainSpessartLogo,
        link: 'https://www.main-spessart.de/',
    },
    {
        name: 'Stadt Alzey',
        logo: alzeyLogo,
        link: 'https://www.alzey.de/',
    },
    {
        name: 'Wartbergbad & Schwimmhalle Alzey',
        logo: alzeySchwimmbadLogo,
        link: 'https://www.schwimmbad-alzey.de/',
    },
    {
        name: 'Landkreis Alzey-Worms',
        logo: alzeyWormsLogo,
        link: 'https://www.kreis-alzey-worms.de/',
    },
    {
        name: 'Gesundheitsamt Main-Spessart',
        logo: gsMainSpessartLogo,
        link: 'https://www.main-spessart.de/themen/gesundheit-soziales/gesundheitsregion-plus/index.html',
    },
    {
        name: 'Kieler Bäder',
        logo: kielerBaederLogo,
        link: 'http://www.kieler-baeder.de',
    },
    {
        name: 'KölnBäder',
        logo: koelnBaederLogo,
        link: 'https://koelnbaeder.de/',
    },
    {
        name: 'MSD',
        logo: msdLogo,
        link: 'https://www.msd.de/',
    },
    {
        name: 'Calevornia',
        logo: calevorniaLogo,
        link: 'https://www.calevornia.de/',
    },
    {
        name: 'Leverkusen Sportpark',
        logo: leverkusenSportparkLogo,
        link: 'https://www.sportpark-lev.de/',
    },
    {
        name: 'Universitätsmedizin Mainz',
        logo: mainzUniMedizinLogo,
        link: 'https://www.unimedizin-mainz.de/uct',
    },
    {
        name: 'Stadtwerke Saarbrücken Bäder',
        logo: saarbrueckenBaederLogo,
        link: 'https://www.saarbruecker-baeder.de/',
    },
    {
        name: 'Hallen- und Freibad Wiembachtal',
        logo: wiembachtalLogo,
        link: 'https://www.bad-wiembachtal.de/',
    },
    {
        name: 'AOK PLUS - Die Gesundheitskasse für Sachsen und Thüringen',
        logo: aokPlusLogo,
        link: 'https://www.aok.de/pk/plus/',
    },
    {
        name: 'Landratsamt Ludwigsburg',
        logo: landratsamtLudwigsburgLogo,
        link: 'https://www.landkreis-ludwigsburg.de/de/gesundheit-veterinaerwesen/gesundheit/',
    },
    {
        name: 'Kreisverwaltung Saarpfalz-Kreis',
        logo: kreisverwaltungSaarpfalzLogo,
        link: 'https://www.saarpfalz-kreis.de/',
    },
    {
        name: 'Stadtpark Norderstedt',
        logo: stadtparkNorderstedtLogo,
        link: 'http://www.stadtpark-norderstedt.de',
    },
    {
        name: 'Landratsamt Bamberg',
        logo: landratsamtBambergLogo,
        link: 'https://bamberg.gesundheitsregion-plus.de',
    },
    {
        name: 'Kreis Segeberg',
        logo: segebergLogo,
        link: 'https://www.segeberg.de/Lebenslagen/Gesundheit/Hitze-Portal/',
    },
    {
        name: 'Freibad Lentföhrden',
        logo: freibadLentfoehrdenLogo,
        link: 'https://freibad.lentfoehrden.de/',
    },
    {
        name: 'Gemeinde Henstedt-Ulzburg',
        logo: henstedtUlzburgLogo,
        link: 'https://www.henstedt-ulzburg.de/',
    },
    {
        name: 'AOK Bayern',
        logo: aokLogo,
        link: 'https://www.aok.de/bayern',
    },
    {
        name: 'Gesundheitsregion plus Berchtesgadener Land',
        logo: berchtesgadenerLandLogo,
        link: 'https://www.lra-bgl.de',
    },
    {
        name: 'GC Münster-Tinnen',
        logo: golfclubMuensterLogo,
        link: 'https://www.gc-tinnen.de/',
    },
    {
        name: 'Landkreis Marburg-Biedenkopf',
        logo: marburgBiedenkopfLogo,
        link: 'https://www.marburg-biedenkopf.de',
    },
    {
        name: 'Stadt Eberswalde',
        logo: eberswaldeLogo,
        link: 'https://www.eberswalde.de',
    },
    {
        name: 'Landratsamt Bayreuth',
        logo: bayreuthLogo,
        link: 'https://www.landkreis-bayreuth.de',
    },
    {
        name: 'Verbraucherschutz- und Gesundheitsamt - Landkreis Barnim',
        logo: barnimLogo,
        link: 'https://www.barnim.de',
    },
    {
        name: 'Stadtverwaltung Worms',
        logo: wormsLogo,
        link: 'https://www.worms.de/neu-de/zukunft-gestalten/klima-und-umwelt/Team-Klima/',
    },
    {
        name: 'Gesundheitsregion PLUS Bayreuth - Landratsamt Bayreuth',
        logo: bayreuthPlusLogo,
        link: 'https://www.landkreis-bayreuth.de',
    },
    {
        name: 'Landesamt für Gesundheit und Soziales',
        logo: laGeSoLogo,
        link: 'https://www.berlin.de/lageso/',
    },
    {
        name: 'Waldband Lamspringe',
        logo: waldbadLamspringeLogo,
        link: 'https://www.waldbad-lamspringe.com/',
    },
    {
        name: 'AOK Rheinland/Hamburg',
        logo: aokRheinlandHamburgLogo,
        link: 'https://www.aok.de/pk/rh/',
    },
    {
        name: 'Universitätsstadt Siegen',
        logo: siegenLogo,
        link: 'https://www.siegen.de/hitze',
    },
    {
        name: 'Gemeinde Herscheid',
        logo: herscheidLogo,
        link: 'https://www.herscheid.de/',
    },
    {
        name: 'Felsenbad Landsberg',
        logo: felsenbadLandsbergLogo,
        link: 'https://www.stadt-landsberg.de/de/felsenbad.html',
    },
    {
        name: 'Wasserwelt Langenhagen',
        logo: wasserweltLangenhagenLogo,
        link: 'https://www.wasserwelt-langenhagen.de/',
    },
    {
        name: 'StadtWerke Rösrath AöR',
        logo: stadtwerkeRoesrathLogo,
        link: 'https://www.stadtwerke-roesrath.de/',
    },
    {
        name: 'GochNess – Erlebnisbad & Saunalandschaft',
        logo: gochnessBadLogo,
        link: 'https://gochness.de/',
    },
    {
        name: 'Barockstadt Ettenheim',
        logo: ettenheimLogo,
        link: 'https://www.ettenheim.de/)',
    },
];